import { NgModule } from '@angular/core';
import { BreadcrumbSchemaBuilder, JSONLD_PRODUCT_BUILDER, SCHEMA_BUILDER } from '@spartacus/storefront';
import { JsonLdBaseProductBuilder, ProductSchemaBuilder } from './product';

/**
 * Provides several standard json-ld builders that contribute to collecting and building json-ld data.
 */
@NgModule({
  providers: [
    {
      provide: SCHEMA_BUILDER,
      useExisting: ProductSchemaBuilder,
      multi: true,
    },
    {
      provide: SCHEMA_BUILDER,
      useExisting: BreadcrumbSchemaBuilder,
      multi: true,
    },
    // lower level json-ld builder classes offering fine-grained control for product related schemas
    {
      provide: JSONLD_PRODUCT_BUILDER,
      useExisting: JsonLdBaseProductBuilder,
      multi: true,
    },
  ],
})
export class JsonLdBuilderModule {}
